import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StudyGroupCard = ({ group, onJoin }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">{group?.name}</h3>
          <p className="text-sm text-muted-foreground mb-3">{group?.description}</p>
        </div>
        {group?.isActive && (
          <div className="flex items-center gap-1 text-xs text-green-600 bg-green-100 dark:bg-green-900/30 px-2 py-1 rounded-full">
            <div className="w-2 h-2 rounded-full bg-green-600 animate-pulse" />
            <span>Active</span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 mb-4">
        <div className="flex -space-x-2">
          {group?.members?.slice(0, 4)?.map((member, index) => (
            <Image
              key={index}
              src={member?.avatar}
              alt={member?.avatarAlt}
              className="w-8 h-8 rounded-full border-2 border-card object-cover"
            />
          ))}
        </div>
        <span className="text-sm text-muted-foreground">
          {group?.memberCount} members
        </span>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Calendar" size={16} />
          <span>Next session: {group?.nextSession}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="MessageCircle" size={16} />
          <span>{group?.discussions} active discussions</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Target" size={16} />
          <span>Focus: {group?.focus}</span>
        </div>
      </div>
      <Button
        variant={group?.joined ? 'outline' : 'default'}
        fullWidth
        onClick={() => onJoin(group)}
        iconName={group?.joined ? 'Check' : 'UserPlus'}
        iconPosition="left"
      >
        {group?.joined ? 'Joined' : 'Join Group'}
      </Button>
    </div>
  );
};

export default StudyGroupCard;